import React, { createContext, useContext, useMemo, useCallback } from "react";
import ar from "./ar.json";
import en from "./en.json";

const dictionaries = { ar, en };

export const SUPPORTED_LANGS = ["ar", "en"];
export const DEFAULT_LANG = "ar";

const I18nContext = createContext({ lang: DEFAULT_LANG, t: (k) => k });

function getNested(obj, path) {
  return path.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), obj);
}

export function I18nProvider({ lang, children }) {
  const activeLang = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;

  const t = useCallback(
    (key, fallback) => {
      const value = getNested(dictionaries[activeLang], key);
      if (value === undefined) return fallback !== undefined ? fallback : key;
      return value;
    },
    [activeLang]
  );

  const value = useMemo(() => ({ lang: activeLang, t }), [activeLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export function useT() {
  return useContext(I18nContext).t;
}
